import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-linen text-black border-t-2 border-black">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10 py-14">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <p className="lif-wordmark text-3xl md:text-4xl mb-5">Love, in Full</p>
            <p className="leading-relaxed max-w-md text-black/80">
              A curated global database celebrating authentic and diverse partnerships - built so the wedding
              industry can finally represent every kind of love story.
            </p>
            <p className="mt-6 text-black/70">
              A sibling platform of{" "}
              <a href="https://dancingwithher.com" target="_blank" rel="noreferrer" className="lif-link">Dancing With Her</a> &amp;{" "}
              <a href="https://dancingwiththem.com" target="_blank" rel="noreferrer" className="lif-link">Dancing With Them</a>
            </p>
          </div>

          <div className="md:col-span-3 md:col-start-7">
            <p className="lif-overline mb-4">For Lovers</p>
            <ul className="space-y-2 text-black/85">
              <li><Link to="/join?role=couple" className="hover:text-wine transition">Add your listing</Link></li>
              <li><Link to="/opportunities" className="hover:text-wine transition">Look at opportunities</Link></li>
              <li><Link to="/dashboard/lovers" className="hover:text-wine transition">Manage your profile</Link></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="lif-overline mb-4">For Vendors</p>
            <ul className="space-y-2 text-black/85">
              <li><Link to="/join?role=vendor" className="hover:text-wine transition">Apply</Link></li>
              <li><Link to="/directory" className="hover:text-wine transition">Browse directory</Link></li>
              <li><Link to="/dashboard/vendor" className="hover:text-wine transition">Post opportunities</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-5 border-t-2 border-black flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-sm text-black/70">
          <p>© {new Date().getFullYear()} Love, in Full</p>
          <p>We don't define love - we just make it more visible 🌈</p>
          <Link to="/privacy" className="hover:text-wine transition underline-offset-4 hover:underline" data-testid="footer-privacy-link">
            Privacy, security &amp; data safety
          </Link>
        </div>
      </div>
    </footer>
  );
}
